export default __webpack_public_path__ + "static/media/4-progressao.13801a15.svg";